import { render, staticRenderFns } from "./TableWidgetAdded.vue?vue&type=template&id=156e2b58"
import script from "./TableWidgetAdded.vue?vue&type=script&lang=js"
export * from "./TableWidgetAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports